<div style="background-color:#f7f4ea" class="container3" style="margin-top:60px !important">
<div class="col-sm-12 col-md-12 col-lg-12 col-xl-12" style="padding:0px;">
  <div>
<img src="https://petcart.in/webassets/sliders/knowledge.jpg" style="width:100%;">

  </div>
</div>


      <section class="categories_area clearfix" id="about">
    <div class="container"  >
        <div class="row" >
            <div class="col-12 col-md-6 col-lg-4 col-xl-4">
              <div class="card bg-secondary" style="background-color: #f7f4ea!important;">
                <img class="card-img-top" style="width:100%;  max-height: 196px;" src="https://passport.petcart.in/images/blogimage/health.jpeg" alt="Card image">

               <div class="card-footer">
                  <div class="row">
                    <div class="col-12 text-center">
                        <a (click)="setmaincategory('Health and Wellness')">
                          <h4 style="font-style: open sans ; font-size: 20px; color: #9b7544">Health And Wellness</h4>
                        </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4 col-xl-4">

              <div class="card bg-secondary" style="background-color: #f7f4ea!important;">
                <img class="card-img-top" style="width:100%;  max-height: 196px;" src="https://passport.petcart.in/images/blogimage/behaviour.jpeg" alt="Card image">

               <div class="card-footer">
                  <div class="row">
                    <div class="col-12 text-center">
                        <a (click)="setmaincategory('Behaviour')">
                          <h4 style="font-style: open sans ; font-size: 20px; color: #9b7544">Behaviour</h4>
                        </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>








            <div class="col-12 col-md-6 col-lg-4 col-xl-4">

              <div class="card bg-secondary" style="background-color: #f7f4ea!important;">
                <img class="card-img-top" style="width:100%;  max-height: 196px;" src="https://passport.petcart.in/images/blogimage/care.jpeg" alt="Card image">

               <div class="card-footer">
                  <div class="row">
                    <div class="col-12 text-center">
                        <a (click)="setmaincategory('Care and General Management')">
                          <h4 style="font-style: open sans ; font-size: 20px; color: #9b7544">Care and General Management</h4>
                        </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>




            <div class="col-12 col-md-6 col-lg-4 col-xl-4" style="margin-top: 15px;">

              <div class="card bg-secondary" style="background-color: #f7f4ea!important;">
                <img class="card-img-top" style="width:100%;  max-height: 196px;" src="https://passport.petcart.in/images/blogimage/breed.jpeg" alt="Card image">

               <div class="card-footer">
                  <div class="row">
                    <div class="col-12 text-center">
                        <a (click)="setmaincategory('Breed')">
                          <h4 style="font-style: open sans ; font-size: 20px; color: #9b7544">Breed</h4>
                        </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4 col-xl-4" style="margin-top: 15px;">
              <div class="card bg-secondary" style="background-color: #f7f4ea!important;">
                <img class="card-img-top" style="width:100%;  max-height: 196px;" src="https://passport.petcart.in/images/blogimage/diet.jpeg" alt="Card image">

               <div class="card-footer">
                  <div class="row">
                    <div class="col-12 text-center">
                        <a (click)="setmaincategory('Nutrition and Diet')">
                          <h4 style="font-style: open sans ; font-size: 20px; color: #9b7544">Nutrition And diet</h4>
                        </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>






            <div class="col-12 col-md-6 col-lg-4" style="margin-top: 15px;">

              <div class="card bg-secondary" style="background-color: #f7f4ea!important;">
                <img class="card-img-top" style="width:100%;  max-height: 196px;" src="https://passport.petcart.in/images/blogimage/dogshow.jpeg" alt="Card image">

               <div class="card-footer">
                  <div class="row">
                    <div class="col-12 text-center">
                      <a (click)="setmaincategory('Dog Shows')">
                          <h4 style="font-style: open sans ; font-size: 20px; color: #9b7544">Dog Shows</h4>
                        </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>

    </div>
</section>
<section class="blog_area section_padding_0_80">
  <div class="container">
      <div class="row" *ngIf="blog && blog.length> 0">
          <div class="col-sm-12 col-md-6 col-lg-8 col-xl-8">
              <div class="single-post wow fadeInUp" data-wow-delay=".2s">
              <div class="post-thumb">
                  <img style="width:100%;" src="https://passport.petcart.in/images/blogimage/{{blog[0].blogcoverimg}}" alt="">
              </div>
              <div class="post-content">
                  <div class="post-meta d-flex">
                      <div class="post-author-date-area d-flex">
                          <!-- Post Author -->
                          <div class="post-author">
                              <a href="#">By Petcart</a>
                          </div>
                          <!-- Post Date -->
                          <div class="post-date">
                              <a href="#">{{blog[0].created_at | slice:0:10}}</a>
                          </div>
                      </div>
                      <!-- Post Comment & Share Area -->
                      <div class="post-comment-share-area d-flex">
                          <!-- Post Comments -->
                          <div class="post-comments">
                              <a href="#"><i class="fa fa-comment-o" aria-hidden="true"></i>{{commentsarray['id' + blog[0].id]}} </a>
                          </div>
                          <!-- Post Share -->
                          <div class="post-share">
                              <a href="#"><i class="fa fa-share-alt" aria-hidden="true"></i></a>
                          </div>
                      </div>
                  </div>
                  <a href="#">
                      <h2 class="post-headline">{{blog[0].title}}</h2>
                  </a>
                  <p [innerHTML]="blog[0].body | slice: 0: 200"></p>
                  <a (click)="goToDetail(blog[0].id, blog[0].url)"  class="read-more">Continue Reading..</a>
              </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6" *ngFor="let data of blog | slice: 1">
                    <div class="single-post wow fadeInUp" data-wow-delay=".2s">
                        <div class="post-thumb">
                            <img style="width:100%; max-height:200px" src="https://passport.petcart.in/images/blogimage/{{data.blogcoverimg}}" alt="">
                        </div>
                        <div class="post-content">
                            <div class="post-meta d-flex">
                                <div class="post-author-date-area d-flex">
                                    <!-- Post Author -->
                                    <div class="post-author">
                                        <a href="#">By Petcart</a>
                                    </div>
                                    <!-- Post Date -->
                                    <div class="post-date">
                                        <a href="#">{{data.created_at | slice:0:10}}</a>
                                    </div>
                                </div>
                                <!-- Post Comment & Share Area -->
                                <div class="post-comment-share-area d-flex">
                                    <!-- Post Comments -->
                                    <div class="post-comments">
                                        <a href="#"><i class="fa fa-comment-o" aria-hidden="true"></i>{{commentsarray['id' + data.id]}} </a>
                                    </div>
                                    <!-- Post Share -->
                                    <div class="post-share">
                                        <a href="#"><i class="fa fa-share-alt" aria-hidden="true"></i></a>
                                    </div>
                                </div>
                            </div>
                            <a href="#">
                                <h2 class="post-headline">{{data.title}}</h2>
                            </a>
                            <p [innerHTML]="data.body | slice: 0: 200"></p>
                            <a (click)="goToDetail(data.id, data.url)" class="read-more">Continue Reading..</a>
                        </div>
                        </div>
                </div>
              </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
             <div class="card" style="border-radius:30px;border: 1px solid #cd983f;">
                <div class="filter-header text-center" style="    border-radius: 20px 20px 0 0;">
               Categories
              </div>
              <div *ngIf="allblogs">
                     <div *ngFor="let datan of allblogs | uniquefilter2 : 'category'">
                         <p class="filterel" (click)="setmaincategory(datan.category)">{{datan.category}} ({{categoryCount(datan.category)}})</p>
                    </div>
                   </div>
             <div class="filter-header text-center" >
                            Pet Type
             </div>
             <div *ngIf="breed && allblogs">
                <div  *ngFor= "let data of breed">
                   <div *ngFor="let datan of allblogs | uniquefilter2 : 'pet_type'">
                     <div *ngIf="datan.pet_type == data.id" >
                       <p class="filterel" (click)=" setPetTypecategory(data.id)" >{{data.name}} ({{pettypeCount(datan.pet_type)}})</p>
                  </div>
                 </div>
               </div>
             </div>
              <div class="filter-header text-center" >
                Breed
                 </div>
                 <div *ngIf="breed && allblogs">
                 <div  *ngFor= "let data of breed">
                    <div *ngFor="let datan of allblogs | uniquefilter2 : 'breed_id'">
                      <div *ngIf="datan.breed_id == data.id">
                        <p class="filterel" (click)="setBreedcategory(data.id)">{{data.name}} ({{breedCount(datan.breed_id)}})</p>
                   </div>
                  </div>
                </div>
              </div>
                 <div class="filter-header text-center" >
                   Pet Lifestage
                    </div>
                    <div *ngIf="lifestage && allblogs">
                        <div  *ngFor= "let data of lifestage">
                           <div *ngFor="let datan of allblogs  | uniquefilter2 : 'lifestage_id'">
                             <div *ngIf="datan.lifestage_id == data.id">
                               <p class="filterel" (click)="setLifestagecategory(data.id)">{{data.name}} ({{lifestageCount(datan.lifestage_id)}})</p>
                          </div>
                         </div>
                       </div>
                     </div>
            </div>
          </div>
        </div>
  </div>
  </section>
    </div>
